import { INVOICE_STATUS } from '../utils/typeAdapters';
const MOCK_INVOICES = [{
  id: 'INV-001',
  amountDue: 200.0,
  currencyCode: 'USD',
  downloadLink: 'https://hubspot-883512142.hs-sitesqa.com/zjv416nLjxsUpY3u7wCi',
  dueDate: 1747526400000,
  invoiceDate: 1715558400000,
  invoiceFrequencyType: 'RECURRING',
  invoiceLink: 'https://hubspot-883512142.hs-sitesqa.com/zjv416nLjxsUpY3u7wCi',
  status: INVOICE_STATUS.OPEN
}, {
  id: 'INV-002',
  amountDue: 200.0,
  currencyCode: 'USD',
  downloadLink: 'https://hubspot-883512142.hs-sitesqa.com/zjv416nLjxsUpY3u7wCi',
  dueDate: 1744848000000,
  invoiceDate: 1712966400000,
  invoiceFrequencyType: 'RECURRING',
  invoiceLink: 'https://hubspot-883512142.hs-sitesqa.com/zjv416nLjxsUpY3u7wCi',
  status: INVOICE_STATUS.PAID
}, {
  id: 'INV-003',
  amountDue: 200.0,
  currencyCode: 'USD',
  downloadLink: 'https://hubspot-883512142.hs-sitesqa.com/zjv416nLjxsUpY3u7wCi',
  dueDate: 1742083200000,
  invoiceDate: 1710288000000,
  invoiceFrequencyType: 'RECURRING',
  invoiceLink: 'https://hubspot-883512142.hs-sitesqa.com/zjv416nLjxsUpY3u7wCi',
  status: INVOICE_STATUS.PAST_DUE
}, {
  id: 'INV-004',
  amountDue: 150.0,
  currencyCode: 'USD',
  downloadLink: 'https://hubspot-883512142.hs-sitesqa.com/zjv416nLjxsUpY3u7wCi',
  dueDate: 1739404800000,
  invoiceDate: 1707696000000,
  invoiceFrequencyType: 'ONE_TIME',
  invoiceLink: 'https://hubspot-883512142.hs-sitesqa.com/zjv416nLjxsUpY3u7wCi',
  status: INVOICE_STATUS.DRAFT
}, {
  id: 'INV-005',
  amountDue: 0.0,
  currencyCode: 'USD',
  downloadLink: 'https://hubspot-883512142.hs-sitesqa.com/zjv416nLjxsUpY3u7wCi',
  dueDate: 1736726400000,
  invoiceDate: 1705017600000,
  invoiceFrequencyType: 'RECURRING',
  invoiceLink: 'https://hubspot-883512142.hs-sitesqa.com/zjv416nLjxsUpY3u7wCi',
  status: INVOICE_STATUS.VOIDED
}];
const MOCK_SUBSCRIPTIONS = [{
  subscriptionId: 1,
  name: 'Starter Plan',
  status: 'ACTIVE',
  currencyCode: 'USD',
  isAutoCollectPayment: true,
  startDate: 1715558400000,
  endDate: 1747094400000,
  nextPaymentDate: 1752278400000,
  nextPaymentAmount: 750.0,
  updateRequestURL: 'https://payments-na1.hubspotqa.com/payments/update/hspu_wdwq6MV6QvRMfm9aKHqb',
  paymentMethodDetails: {
    type: 'VISA',
    last4: '4242'
  }
}, {
  subscriptionId: 2,
  name: 'Professional Plan',
  status: 'INACTIVE',
  currencyCode: 'USD',
  isAutoCollectPayment: false,
  startDate: 1710288000000,
  endDate: 1742083200000,
  nextPaymentDate: null,
  nextPaymentAmount: null,
  updateRequestURL: 'https://payments-na1.hubspotqa.com/payments/update/hspu_abc123xyz',
  paymentMethodDetails: {
    type: 'MASTERCARD',
    last4: '5678'
  }
}, {
  subscriptionId: 3,
  name: 'Enterprise Plan',
  status: 'UNPAID',
  currencyCode: 'USD',
  isAutoCollectPayment: true,
  startDate: 1712966400000,
  endDate: 1744848000000,
  nextPaymentDate: 1747526400000,
  nextPaymentAmount: 1500.0,
  updateRequestURL: 'https://payments-na1.hubspotqa.com/payments/update/hspu_def456uvw',
  paymentMethodDetails: {
    type: 'VISA',
    last4: '9999'
  }
}, {
  subscriptionId: 4,
  name: 'Growth Plan',
  status: 'SCHEDULED',
  currencyCode: 'USD',
  isAutoCollectPayment: true,
  startDate: 1755043200000,
  endDate: 1786579200000,
  nextPaymentDate: 1755043200000,
  nextPaymentAmount: 950.0,
  updateRequestURL: 'https://payments-na1.hubspotqa.com/payments/update/hspu_ghi789rst',
  paymentMethodDetails: {
    type: 'AMEX',
    last4: '1111'
  }
}, {
  subscriptionId: 5,
  name: 'Basic Plan',
  status: 'PAUSED',
  currencyCode: 'USD',
  isAutoCollectPayment: false,
  startDate: 1707696000000,
  endDate: 1739404800000,
  nextPaymentDate: null,
  nextPaymentAmount: null,
  updateRequestURL: 'https://payments-na1.hubspotqa.com/payments/update/hspu_jkl012mno',
  paymentMethodDetails: {
    type: 'DISCOVER',
    last4: '2222'
  }
}];
const MOCK_INVOICES_WITH_NULLS = [{
  id: 'INV-PARTIAL-001',
  amountDue: null,
  currencyCode: null,
  downloadLink: null,
  dueDate: null,
  invoiceDate: 1715558400000,
  invoiceFrequencyType: 'RECURRING',
  invoiceLink: 'https://hubspot-883512142.hs-sitesqa.com/zjv416nLjxsUpY3u7wCi',
  status: null
}, {
  id: null,
  amountDue: 150.0,
  currencyCode: 'USD',
  downloadLink: 'https://hubspot-883512142.hs-sitesqa.com/zjv416nLjxsUpY3u7wCi',
  dueDate: 1747526400000,
  invoiceDate: null,
  invoiceFrequencyType: null,
  invoiceLink: null,
  status: 'DUE'
}];
const MOCK_SUBSCRIPTIONS_WITH_NULLS = [{
  subscriptionId: 2,
  name: null,
  status: 'ACTIVE',
  currencyCode: 'USD',
  isAutoCollectPayment: true,
  startDate: 1715558400000,
  endDate: null,
  nextPaymentDate: null,
  nextPaymentAmount: null,
  updateRequestURL: null,
  paymentMethodDetails: null
}, {
  subscriptionId: 3,
  name: 'Pro Plan',
  status: 'ACTIVE',
  currencyCode: 'EUR',
  isAutoCollectPayment: false,
  startDate: 1715558400000,
  endDate: 1747094400000,
  nextPaymentDate: 1752278400000,
  nextPaymentAmount: 1000.0,
  updateRequestURL: 'https://payments-na1.hubspotqa.com/payments/update/hspu_test123',
  paymentMethodDetails: {
    type: 'MASTERCARD',
    last4: '5678'
  }
}];
export { MOCK_INVOICES, MOCK_SUBSCRIPTIONS, MOCK_INVOICES_WITH_NULLS, MOCK_SUBSCRIPTIONS_WITH_NULLS };